export enum UserAttenderStatus {
  USER_STATUS_NOT_REGISTERED = 0,
  USER_STATUS_CONFIRMED = 1,
  USER_STATUS_WAITING = 2,
  USER_STATUS_PENDING = 3,
  USER_STATUS_CANCELED = 4
}
